const authReducer = (state = { email: null, isLogged: false }, action) => {
    let {type, payload} = action;
    switch (type) {
        case "LOGIN_SUCCESS":
            localStorage.setItem("auth", JSON.stringify(payload));
            return payload; 
        case "UPDATE_DATA":
            localStorage.setItem("auth", JSON.stringify(payload));
            return payload;
        case "LOGOUT_SUCCESS":
            localStorage.removeItem("auth");
            return payload;
        default:
            return state;
    }
}

export default authReducer;